import { render, staticRenderFns } from "./LandingBannner.vue?vue&type=template&id=5d37ae4e&scoped=true"
import script from "./LandingBannner.vue?vue&type=script&lang=js"
export * from "./LandingBannner.vue?vue&type=script&lang=js"
import style0 from "./LandingBannner.vue?vue&type=style&index=0&id=5d37ae4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d37ae4e",
  null
  
)

export default component.exports